import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import './UserSurvey.css';
import apiService from 'services/apiService';
import {
    reportError,
} from 'actions/errorActions';

const UserSurvey = () => {
    const [content, setContent] = useState({}); //for response tracking
    const [step, setStep] = useState(0); //for survey step tracking
    const [openform, setOpenform] = useState('') //for updating text box in open form questions
    const [open, setOpen] = useState(false) //for closing the survey
    const [submitted, setSubmitted] = useState(false) //set when answer is submitted
    const dispatch = useDispatch();
    

    //set survey question data, after initial commit add and switch to translations
    const questions = [
        {
            id : 0,
            header: 'Hei! Voit auttaa meitä kehittämään Lakitutkaa vastaamalla käyttäjäkyselyyn:',
            question : 'Mikä käyttäjäryhmä kuvaa sinua parhaiten?',
            options : ['Tutkija', 'Opiskelija', 'Muu'],
            type: 'button'
        },
        {
            id : 1,
            header: '2/3',
            question : 'Etsitkö tietoa ajankohtaisista vai menneistä lakihankkeista?',
            options : ['Ajankohtaisista', 'Menneistä', 'Molemmista'],
            type: 'button'
        },
        {
            id : 2,
            header: '3/3',
            question : 'Voit kertoa Lakitutkan käytöstäsi lisää tässä',
            options : 'Lähetä',
            type: 'open'
        },
        {
            id : 3,
            header: '',
            question : 'Kiitos vastauksista! Voit sulkea kyselyn.', 
            options : 'Sulje',
            type: 'endSurvey'
        }
    ];

    const handleSurvey = (answer) => { //for navigation of the survey
        setContent({...content, [step]: answer}); //save answers
        if (step < questions.length-1) { //move to next question
            setStep(step+1);
        };
    };

    const handleSend = async (event) => {
        if (submitted === false & JSON.stringify(content) !== '{}') {
            try {
                await apiService.sendSurvey(
                    JSON.stringify(content)
                );
                setSubmitted(true);
            } catch (err) {
                dispatch(reportError(err));
            }
        }
    };

    const closeSurvey = () => {
        setOpen(true);
        handleSend();
    };

    return (
        open === false ? (
        <div className='survey-base'>
            <div className='survey-toolbar'>
                <button
                    className='close-button'
                    onClick={closeSurvey}
                >
                    X
                </button>
                <div 
                    className='greytext'> {questions[step].header}
                </div>
            </div>
            <div className='question-text'>
                {questions[step].question}
            </div>
            {questions[step].type === 'button' ? (
                <div className='survey-options'>
                    {questions[step].options.map((option) => (
                        <button
                            key={option} 
                            onClick={() => handleSurvey(option)}
                            className='option-button'
                        >
                            {option}
                        </button>
                        )
                    )}
                </div>
            ) : questions[step].type === 'open' ? (
                <div>
                    <div className='greytext'>*vapaaehtoinen*</div>
                    <textarea
                        placeholder='...'
                        value={openform}
                        onChange={(e) => setOpenform(e.target.value)}
                    />
                    <button
                        onClick={() => handleSurvey(openform)}
                        className='submit-button'
                    >
                        {questions[step].options}
                    </button>
                </div>
            ) : questions[step].type === 'endSurvey' ? (
                <></>
            ) : (    
                <>{console.log('check question type')}</>
            )}
        </div>
    ) : (
        <></>
    ));
};

export default UserSurvey;